import { css } from "@emotion/react";
import { MEDIA_QUERY_FOR_SP } from "constants/mediaQueryForSp";
import { whiteBaseButtonStyle } from "pages/AccountSettlementHistoryOrderId/styles/commonStyles";

export const rootStyle = css`
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  padding: 20px 16px;

  ${MEDIA_QUERY_FOR_SP} {
    padding: 24px 16px;
  }
`;

export const topContentStyle = css`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
`;

export const purchaseDateStyle = css`
  font-size: 16px;
`;

export const statusBadgeStyle = css`
  display: flex;
  height: 24px;
  padding-left: 8px;
  padding-right: 8px;
  align-items: center;
  background-color: #333;
  /*テキストスタイル */
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
`;

export const orderInfoWrapperStyle = css`
  display: flex;
  flex-direction: column;
  row-gap: 4px;
`;

export const orderNumberRowStyle = css`
  display: flex;
  flex-direction: row;
  height: 32px;
  align-items: center;
  column-gap: 2px;
`;

export const copyButtonWrapperStyle = css`
  height: 32px;
  padding-inline: 0;
  background: none;
  border: none;
  cursor: pointer;
  color: #000000;
`;

export const alertTextStyle = css`
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: #e53e3e;
`;

export const receiptButtonStyle = css`
  ${whiteBaseButtonStyle};
  width: 132px;
`;

export const trackingInfoWrapperStyle = css`
  display: flex;
  flex-direction: column;
  row-gap: 4px;
`;

export const trackingButtonStyle = css`
  ${whiteBaseButtonStyle};
  width: fit-content;
  display: flex;
  align-items: center;
  column-gap: 8px;
  padding-left: 12px;
  padding-right: 12px;
  height: 32px;
`;
